import { Injectable } from "@angular/core";
import { ApiService } from "@youm-front/api/data-access";
import { Observable } from "rxjs";
import {
  RoomStreamActiveDeleteRequestDTO,
  RoomStreamActiveSetRequestDTO
} from "../dto";

@Injectable()
export class RoomStreamService {
  constructor(private readonly apiService: ApiService) {}

  roomStreamActiveDelete(
    roomStreamActiveDeleteRequestDTO: RoomStreamActiveDeleteRequestDTO
  ): Observable<void> {
    const { roomId, streamId } = roomStreamActiveDeleteRequestDTO.data;

    return this.apiService.delete<void>(
      `rooms/${roomId}/streams/${streamId}/active`
    );
  }

  roomStreamActiveSet(
    roomStreamActiveSetRequestDTO: RoomStreamActiveSetRequestDTO
  ): Observable<void> {
    const { roomId, streamId } = roomStreamActiveSetRequestDTO.data;

    return this.apiService.post<void>(
      `rooms/${roomId}/streams/${streamId}/active`,
      {}
    );
  }
}
